import script from "./Strategy.vue?vue&type=script&setup=true&lang=js"
export * from "./Strategy.vue?vue&type=script&setup=true&lang=js"

import "./Strategy.vue?vue&type=style&index=0&id=19682732&scoped=true&lang=css"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-19682732"]])

export default __exports__